export default "__VITE_ASSET__384731b3__"